export default "__VITE_ASSET__D8PT132___"